import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../../../../hooks";
import { NewCheckbox } from "../../../../shared-components";
import ErrorField from "./ErrorField";

const LegalConsentField = ({
  form,
  disableForm,
  onRadioBtnChange,
  fieldStatus,
  submitted
}) => {
  const { trans } = useTrans();

  const title = trans("Legal consent");

  const subtitle = (
    <>
      <div className="subtitle">
        {/* prettier-ignore */ trans("I confirm the following: ")}
        <br />
        {/* prettier-ignore */ trans("I am not an employee, representative or agent of Wattpad, its parent companies, subsidiaries, affiliates, associated companies, or advertising agencies and I am not an immediate family member of or domiciled with any of the above;")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I am at least 13 years old and, if I am under 18, I have my parent/legal guardian’s permission to enter the Wattys.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("My story was written by me and all materials and information in the story are original to me and do not violate anyone’s copyright, trademark, intellectual property, or other rights. Accounts or Entries generated by script, macro, artificial intelligence (including, without limitation, ChatGPT), or other automated means will be void.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I understand and agree that, if I am selected as a potential winner of the Wattys, Wattpad may include my winning entry (including the cover page), and similar entry information in the winners’ announcements, including during a live show or event.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I consent to the use of (a) my pen name, Platform username, Platform profile photography, social media handles, and other required information and (b) my social posts on Twitter, Instagram, Facebook, the Platform, or any other social media platform made in connection with the Wattys, in any advertising or publicity, without compensation or other liability to me or my heirs, executors, administrators, personal representatives, successors or assigns. Notwithstanding, the Wattys are not affiliated with social platforms.")}
        <br />
        <br />
        {/* prettier-ignore */ trans("I agree to and hereby release, on behalf of my assigns, personal representatives and heirs, Wattpad its parent companies, affiliates, subsidiaries, and advertising, promotion, and fulfillment agencies and all of their respective officers, directors, employees, agents and representatives, and all others associated with the development and execution of the Wattys from and against every claim I may have now and in the future arising out of, or in connection with, the Wattys, including without limitation, liability for personal injury, damage or loss, associated with, said prize awarded or to be awarded.")}
      </div>
    </>
  );

  const errorCondition =
    (fieldStatus.fieldInvalid ||
      (fieldStatus.fieldName !== "legalConsent" &&
        fieldStatus.fieldName !== "" &&
        submitted)) &&
    !form.legalConsent;

  return (
    <div className="legal-consent-container">
      <div className="legal-consent-title-container">
        <h4>{title}</h4>
      </div>
      {subtitle}
      <div className="checkbox-group" id="legal-consent-checkbox">
        <NewCheckbox
          disabled={disableForm}
          name="legalConsent"
          onChange={onRadioBtnChange}
          checked={form.legalConsent}
          contentId="legal-consent-checkbox-message"
        >
          {trans("I agree")}
        </NewCheckbox>
      </div>
      <ErrorField errorCondition={errorCondition} fieldId={"legal-consent"} />
    </div>
  );
};

LegalConsentField.propTypes = {
  form: PropTypes.object.isRequired,
  disableForm: PropTypes.bool.isRequired,
  onRadioBtnChange: PropTypes.func.isRequired,
  fieldStatus: PropTypes.shape({
    fieldInvalid: PropTypes.bool,
    fieldName: PropTypes.string
  }).isRequired,
  submitted: PropTypes.bool.isRequired
};

export default LegalConsentField;
